import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import qs from 'qs';
import { injectIntl, FormattedMessage } from 'react-intl';

import * as actions from '../actions';

import { Spinner } from '@salesforce/design-system-react';
import BrandBand from '../../common/components/BrandBand';
import getStackUrl from '../../utilities/getStackUrl';
import {
  Header,
  EinsteinCard,
  Setup,
  DataResidencyBanner,
  DeleteTags,
  SetupToast
} from '../components';
import redirectToError from '../../utilities/redirectToError';

export class Dashboard extends Component {
  componentDidMount() {
    const parsedQueryString = qs.parse(this.props.location.search.substr(1));
    let options = {
      ...parsedQueryString,
      onError: redirectToError(this.props.history)
    };
    this.props.actions.getActivationStatus(options);
  }

  componentDidUpdate(prevProps) {
    const prevActivation = prevProps.activation;
    const currActivation = this.props.activation;
    const isInactiveStatus =
      currActivation.status === null ||
      currActivation.status === 'deleted' ||
      currActivation.status === 'pause';

    if (
      prevActivation.isLoading === true &&
      currActivation.isLoading === false
    ) {
      //activation succeeded
      if (
        ['active', null].indexOf(prevActivation.status) === -1 &&
        currActivation.status === 'active'
      ) {
        this.props.actions.showToast('activateSuccess');
        //activation failed
      } else if (!prevActivation.error && currActivation.error !== null) {
        this.props.actions.showToast('activateFailure', 'error');
        //delete request succeeded
      } else if (
        prevActivation.status === 'pause' &&
        currActivation.status === 'toDelete'
      ) {
        this.props.actions.showToast('deleteSuccess');
      } else if (
        currActivation.useNestedTagApi &&
        currActivation.version === '1' &&
        isInactiveStatus
      ) {
        this.props.actions.showToast('versionUpgrade', 'info');
      }
    }
  }

  renderSpinner() {
    return (
      <div>
        <Spinner variant="brand" />
      </div>
    );
  }

  renderPage() {
    const { formatMessage } = this.props.intl;
    const regex = /[2,3,4]0[1,2,3,6]/;
    const stackUrl = getStackUrl() || '';
    const displayResidencyBanner = !!stackUrl.match(regex) || false;
    const helpLink =
      'https://help.salesforce.com/s/articleView?id=sf.mc_anb_data_residency_hyperforce.htm&type=5';
    return (
      <BrandBand>
        {this.renderToast()}
        {displayResidencyBanner ? (
          <DataResidencyBanner>
            <FormattedMessage
              id={'DataResidency.dataResidency'}
              values={{
                link: (
                  <a rel="noopener noreferrer" target="_blank" href={helpLink}>
                    {formatMessage({
                      id: 'DataResidency.learnMore'
                    })}
                  </a>
                )
              }}
            />
          </DataResidencyBanner>
        ) : null}
        <Header {...this.props} />
        <EinsteinCard {...this.props} />
        <DeleteTags {...this.props} />
        <Setup {...this.props} />
      </BrandBand>
    );
  }

  renderToast() {
    return <SetupToast {...this.props} toast={this.props.activation.toast} />;
  }

  render() {
    const { isLoading } = this.props.activation;
    return <div>{isLoading ? this.renderSpinner() : this.renderPage()}</div>;
  }
}

Dashboard.propTypes = {
  activation: PropTypes.object,
  children: PropTypes.element,
  actions: PropTypes.object,
  location: PropTypes.object
};

function mapStateToProps(state) {
  return {
    activation: state.setup.activation
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(Dashboard)
);
